'use strict';

module.exports = require('./components/DisqusThread');


//////////////////
// WEBPACK FOOTER
// ./~/react-disqus-comments/build/main.js
// module id = 443
// module chunks = 108009296967943